<template>
  <BaseLoader/>
</template>

<script>
export default {
  name: 'EmptyScreen',
};
</script>

<style scoped>
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
